import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {HttpProvider} from "./../../providers/http/http";
import {HttpHeaders} from "@angular/common/http";
import {TEST} from "../../pages/constants";
import {APIKEY} from "../../pages/constants";

/*
  Generated class for the MapdirectionsProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class MapdirectionsProvider {
  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      "X-Api-Key": APIKEY
    })
  };
  url = "/service/routing";
  params: any;

  constructor(public http: HttpClient, private httpProv: HttpProvider) {
  }

  getRoute(origin, destination) {
    this.params = "?origin=" + origin + "&destination=" + destination;

    return this.httpProv.get(TEST + this.url + this.params, this.httpOptions);
  }
}



// WEBPACK FOOTER //
// ./src/providers/mapdirections/mapdirections.ts